// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3_-57","detailsBorder":"styles_detailsBorder__3SNLe"};